module.exports = __webpack_public_path__ + "img/camp-pass--2x.0882be6b.jpg";